import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import * as XLSX from 'xlsx';


import { ApiLoginService } from '@app/api/api-login.service';
import { ApiContentService } from '@app/api/api-content.service';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { LoadJsService } from '../../load-js/load-js.service';


@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})
export class OrderComponent implements OnInit {
  @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;
  @ViewChild("fileReupload", { static: false })
  fileReupload: ElementRef;

  constructor(
    public restApi:ApiPartnerService,
    private fb: FormBuilder,
    private login: ApiLoginService,
    public partnerService: ApiPartnerService,
    public LoadJsOrder: LoadJsService,
  
  ) { }

  formStb = this.fb.group({
    id : ['']
  });
  form_upload = this.fb.group({
    type : [''],
    name_file: [''],
    value_upload: ['']
  });

  formOrder = this.fb.group({
    partnerid: [''],
    tgl_order: [''],
    grf_number: [''],
    iom_number: [''],
    value_upload: ['']
  })
  formOrderReupload = this.fb.group({
    value_upload: [''],
    id: ['']
  })
  btn_save = true
  btn_loading = false
  loading_create = false
  alert_failed = false
  alert_success = false

  table_load = false
  table_data = false
  form_create = false
  
  data_order_stb:any={}
  data_partner:any={}
  response:any={}
  response_stb_valid:any={}
  response_stb_invalid:any={}

  ngOnInit() {
    this.LoadJsOrder.loadScriptOrderStb()
    this.orderStb()
    this.partner()
  }
  refreshPage() {
    this.table_data = false
    this.LoadJsOrder.loadScriptOrderStb()
    this.orderStb()
    this.partner()
  }

  orderStb() {
    this.table_load = true
    this.restApi.GetOrderStb().subscribe((data: {}) => { 
      this.data_order_stb = data
      // console.log(this.data_order_stb)
        this.table_load = false
        this.table_data = true
    });  
  }
  partner() {
    this.restApi.GetPartner().subscribe((data: {}) => { 
      this.data_partner = data
      // console.log(this.data_order_stb)
    });  
  }

  processFile(event : any) {
    console.log('masuk')
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
      /* first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      this.formOrder.get('value_upload').setValue(XLSX.utils.sheet_to_json(ws, {header:0}));
      this.formOrderReupload.get('value_upload').setValue(XLSX.utils.sheet_to_json(ws, {header:0}));
      // console.log(this.formValidasiOrder.value)
      
    };
    reader.readAsBinaryString(target.files[0]);
  }

  submitSave() {
    this.alert_failed = false
    this.alert_success = false
    // console.log(this.formOrder.value)
    this.restApi.PostUploadOrder(this.formOrder.value)
      .subscribe((data: {}) => { 
        this.response = data
        this.ngOnInit()
        this.LoadJsOrder.loadScriptOrderStb()
        if (this.response.status == true) {
          this.alert_success = true
          this.loading_create = false
        } else {
          this.alert_failed = true
          this.loading_create = false
        }
        this.formOrder.reset()
        this.fileUploader.nativeElement.value = null
        
      }
    );
  }
  
  back() {
    this.form_create = false;
  }

  reset(form: NgForm){
    form.reset(); // or form.resetForm();
  }

  getFormCreate() {
    this.form_create = true;
    //this.loadPartner('');
  }  

  getStbValid(id) {
    // console.log(id)
    this.formStb.get('id').setValue(id);
    this.restApi.GetStbValid(this.formStb.value)
      .subscribe((data: {}) => { 
        this.response_stb_valid = data
        // console.log(this.response_stb)
      }
    );
  }
  getStbInvalid(id) {
    this.formStb.get('id').setValue(id);
    this.restApi.GetStbInvalid(this.formStb.value)
      .subscribe((data: {}) => { 
        this.response_stb_invalid = data
      }
    );
  }
  idReupload(id) {
    this.formOrderReupload.get('id').setValue(id);
  }
  submitSaveReupload() {
    this.alert_failed = false
    this.alert_success = false
    // console.log(this.formOrder.value)
    this.restApi.PostUploadOrderReupload(this.formOrderReupload.value)
      .subscribe((data: {}) => { 
        this.response = data
        this.ngOnInit()
        this.LoadJsOrder.loadScriptOrderStb()
        if (this.response.status == true) {
          this.alert_success = true
          this.loading_create = false
        } else {
          this.alert_failed = true
          this.loading_create = false
        }
        this.formOrderReupload.reset()
        this.fileReupload.nativeElement.value = null
        
      }
    );
  }
}
